import { useEffect, useRef } from 'react'

export const useOnce = (once: () => void, cleanup?: () => void) => {
  const initialRef = useRef(true)

  useEffect(() => {
    if (!initialRef.current) {
      return
    }
    initialRef.current = false
    once()
    if (cleanup) {
      return cleanup
    }
  }, [once, cleanup])
}
